<ng-container *ngIf="!isLoading; else loadingSticker">
  <article
    *ngIf="isWithinTimeframe"
    class="newsticker-container"
    #newstickerContainer
    [style.background]="bgColor"
  >
    <ul class="newsticker-items-list">
      <ng-container *ngFor="let item of items">
        <li class="newsticker-item" #newstickerItems>
          <hdi-link
            *ngIf="item.link"
            [hrefType]="item.link.type"
            [href]="item.link.url"
            [fragment]="item.link.fragment"
            [rel]="item.link.rel"
            [title]="item.link.title"
            [target]="item.link.target"
            [label]="item.link.text | capitalize"
            [type]="inline"
          ></hdi-link>
          <p class="content" [innerHTML]="item.content"></p>
        </li>
      </ng-container>
    </ul>
  </article>
</ng-container>

<!-- Loading Placeholder -->
<ng-template #loadingSticker>
  <hdi-newsticker-loader></hdi-newsticker-loader>
</ng-template>
